var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data && _vm.data.attrs)?_c('div',[_c('div',{staticClass:"G-row"},[_c('div',{staticClass:"G-col-12"},[_c('ContentFragment',{attrs:{"content":_vm.data}})],1)])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }